import NAME from "./constants";

export const getIsLoading = store => store[NAME].isLoading || store[NAME].isLoadingModules || store[NAME].isLoadingActivities;
export const getTrainingList = store => store[NAME].trainingList;
export const getCourseList = store => store[NAME].courseList;
export const getSkillList = store => store[NAME].skillList;
export const getInstructorList = store => store[NAME].instructorList;
export const getUserFieldsDefinition = store => store[NAME].userFieldsDefinition;
export const getTraining = store => store[NAME].training;
export const getModules = store => store[NAME].modules;
export const getActivities = store => store[NAME].activities;
export const getMedia = store => store[NAME].media;
export const getActivityTypes = store => store[NAME].activityTypes;
export const getQuestionTypes = store => store[NAME].questionTypes;
export const getSessionTypes = store => store[NAME].sessionTypes;
export const getActivity = store => store[NAME].activity;
export const getCanAssign = store => store[NAME].canAssign;
export const getAssignedCollaborators = store => store[NAME].assignedCollaborators;
export const getCollaboratorsList = store => store[NAME].collaboratorsList;
export const getTrainingTree = store => store[NAME].trainingTree;